import { BehaviorSubject } from 'rxjs';
import { useBehaviorSubject } from '@poinz/hooks';

const initialPartnerViewState = false;

export const PartnerViewSubject = new BehaviorSubject<boolean>(initialPartnerViewState);

export const usePartnerView = () => useBehaviorSubject<boolean>(PartnerViewSubject);
